import { call, put } from 'redux-saga/effects';

import request from './request';
import {
  createFactoryFailed,
  createFactoryRequested,
  createFactorySucceeded,
  deleteFactoryFailed,
  deleteFactoryRequested,
  deleteFactorySucceeded,
  updateFactoryBackgroundImageFailed,
  updateFactoryBackgroundImageRequested,
  updateFactoryBackgroundImageSucceeded,
  updateFactoryFailed,
  updateFactoryRequested,
  updateFactorySucceeded,
} from '../../../actions';
import api from '../../../api';

export function* createFactoryRequest(data) {
  yield put(createFactoryRequested(data));

  try {
    const {
      item,
      included: { users, factoryMemberships, sites, devices },
    } = yield call(request, api.createFactory, data);

    const action = createFactorySucceeded(item, users, factoryMemberships, sites, devices);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = createFactoryFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* updateFactoryRequest(id, data) {
  yield put(updateFactoryRequested(id, data));

  try {
    const { item } = yield call(request, api.updateFactory, id, data);

    const action = updateFactorySucceeded(item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = updateFactoryFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* updateFactoryBackgroundImageRequest(id, data) {
  yield put(updateFactoryBackgroundImageRequested(id));

  try {
    const { item } = yield call(request, api.updateFactoryBackgroundImage, id, data);

    const action = updateFactoryBackgroundImageSucceeded(item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = updateFactoryBackgroundImageFailed(id, error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* deleteFactoryRequest(id) {
  yield put(deleteFactoryRequested(id));

  try {
    const { item } = yield call(request, api.deleteFactory, id);

    const action = deleteFactorySucceeded(item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = deleteFactoryFailed(id, error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}
